// extracted by mini-css-extract-plugin
export default {"input":"Input_input__E5rzA","error":"Input_error__MApdY","validation-msg":"Input_validation-msg__Izr6f"};